import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../../__legacy__/models/error.model';
import { IApiServiceExport } from '../../../../../__legacy__/services/api.service.export';
import { ExportProjectRequest, GetProjectExportsRequest, GetProjectExportsResponse, IsCurrentExportGeneratedRequest } from './ExportServiceDTOs';

export interface IExportProjectService {
  exportProjectAsync(request: ExportProjectRequest): Promise<void>;
  getProjectExportsAsync(request: GetProjectExportsRequest): Promise<GetProjectExportsResponse>;
  isCurrentExportGeneratedAsync(request: IsCurrentExportGeneratedRequest): Promise<boolean>;
  generateDownloadLinkAsync(exportId: string, dataFilterType: string): Promise<string>;
}

export namespace IExportProjectService {
  export const $: interfaces.ServiceIdentifier<IExportProjectService> = Symbol('EXPORT_PROJECT_SERVICE');
}

@injectable()
export class ExportProjectService implements IExportProjectService {
  constructor(@inject(IApiServiceExport.$) readonly apiServiceExport: IApiServiceExport) {}

  async generateDownloadLinkAsync(exportId: string, dataFilterType: string): Promise<string> {
    const url = '/Export/GenerateDownloadLink';
    const result = await this.apiServiceExport.postAsync<string>(url, { exportId, dataFilterType });

    if (result instanceof ACDLError) {
      throw result;
    }

    return result;
  }

  async exportProjectAsync(request: ExportProjectRequest): Promise<void> {
    const url = '/Export/exportProject';
    const result = await this.apiServiceExport.postAsync(url, request);

    if (result instanceof ACDLError) {
      throw result;
    }
  }

  async getProjectExportsAsync(request: GetProjectExportsRequest): Promise<GetProjectExportsResponse> {
    const url = '/Export/GetProjectExports';
    const result = await this.apiServiceExport.getAsync<GetProjectExportsResponse>(url, { params: request });

    if (result instanceof ACDLError) {
      throw result;
    }

    return result;
  }

  async isCurrentExportGeneratedAsync(request: IsCurrentExportGeneratedRequest): Promise<boolean> {
    const url = '/Export/IsCurrentExportGenerated';
    const result = await this.apiServiceExport.getAsync<boolean>(url, { params: request });

    if (result instanceof ACDLError) {
      throw result;
    }

    return result;
  }
}
